import { ISilentRefreshData } from '../types';

export const defaultSilentRefreshData: ISilentRefreshData = {
  originator: 'userdocks',
  isAllowed: null,
  success: null,
  loginUri: null,
  token: null,
};
